import { analyticWebTrafficActions } from 'store/actions';
import { IAnalyticWebTrafficMeta } from 'store/actions/analytics/ROI/webTraffic';
import { GenericResponse } from 'types/GenericResponse';
import { createAsyncReducer } from 'utils/Redux';

export default createAsyncReducer<IAnalyticWebTrafficMeta, GenericResponse>(
  analyticWebTrafficActions,
);
